
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gC1KiqMEpbATp2P6Hgq4FlMft_KHY42JCKtIBfbwNfxIMeta } from "/codebuild/output/src3891221925/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexD_vnLYRadTtC0C3XX7sjZvDnmyF_7pfULK0OCSwFmfAMeta } from "/codebuild/output/src3891221925/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchKlZQ4Iwkwlpf25G1VOrC6IylNChBj5ZWDru_45k0R2RggMeta } from "/codebuild/output/src3891221925/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexQpfh1t2ZJRaMBkpkVrzm9qU0rvuj_45UUlAR5_inKe5ycMeta } from "/codebuild/output/src3891221925/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93mizlyggazDJyxEoDFA4vYJ_45CznUd_45EynaUTZTx9pxQEMeta } from "/codebuild/output/src3891221925/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexHJChDNU2Ah5DTI9kXP2Cu4aQA_4527CHbMNardOPa6hFEMeta } from "/codebuild/output/src3891221925/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_9349Xt8clcVhUYlnQXHlEkQWv7VbdfKATNLJCheD6BEhMMeta } from "/codebuild/output/src3891221925/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexsP_45Mg7GJhXBCeqgNdvvTos5d__6R4jLv6Ttuo3B3_skMeta } from "/codebuild/output/src3891221925/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_939_wHB7qJj9h2BlpdjjkmzB0G7hMQPPPGKL8KCOBXGRkMeta } from "/codebuild/output/src3891221925/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexvazNCwTpz8C6VdCtK3vS8vmC_0_45r81LSkB3WuZ_45_45OCUMeta } from "/codebuild/output/src3891221925/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as index_45_0GuN_GEEqu_IMa_FXCrQvH3cnJ2VFV_KKGCMvmJT0Meta } from "/codebuild/output/src3891221925/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3891221925/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3891221925/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3891221925/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3891221925/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3891221925/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexHJChDNU2Ah5DTI9kXP2Cu4aQA_4527CHbMNardOPa6hFEMeta || {},
    component: () => import("/codebuild/output/src3891221925/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3891221925/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexsP_45Mg7GJhXBCeqgNdvvTos5d__6R4jLv6Ttuo3B3_skMeta || {},
    component: () => import("/codebuild/output/src3891221925/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3891221925/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexvazNCwTpz8C6VdCtK3vS8vmC_0_45r81LSkB3WuZ_45_45OCUMeta || {},
    component: () => import("/codebuild/output/src3891221925/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: index_45_0GuN_GEEqu_IMa_FXCrQvH3cnJ2VFV_KKGCMvmJT0Meta || {},
    component: () => import("/codebuild/output/src3891221925/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]